export default __webpack_public_path__ + "media/zurb/img/bryan/fav-posts/product_strategy_research_jargon-17ce3764a719a75e98ff1f563fb9d791.png";